import { LogoutAsync } from '@ln/user.client.libs'

const logout = async (isVoluntary) => {
    return await LogoutAsync({ embedShortCircuit: false, redirect: 'login', isVoluntary });
}

export default logout;


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/controllers/logout.js